export default "__VITE_ASSET__jszZtzuK__"